import axios from 'axios';
import { store } from 'store';

const { REACT_APP_BASE_API: baseURL } = process.env;

const LOGOUT_URL = `${baseURL}auth/logout`;

// Revokes the session server-side (best-effort) and always clears local state.
// Uses raw axios (not the intercepted instance) so a 401 cannot trigger the
// refresh interceptor. Never throws: local cleanup must happen even if the
// request fails.
export const performLogout = async (): Promise<void> => {
  const { refresh_token } = store.getState().auth || {};

  try {
    if (refresh_token) {
      await axios.post(LOGOUT_URL, { refresh_token });
    }
  } catch (e) {
    // Ignored on purpose: the server-side revoke is best-effort.
  }

  store.dispatch({ type: 'CLEAR_AUTH_TOKENS' });
  store.dispatch({ type: 'SET_USER', payload: null });
  store.dispatch({ type: 'SET_PLAN_USER', payload: null });
};
